// Configuration Manager
// Automatically selects dev or prod config based on environment

import devConfig from './dev';
import prodConfig from './prod';

// Determine environment
// Priority: REACT_APP_ENV > NODE_ENV > default to 'development'
const getEnvironment = () => {
  // Check for explicit environment variable
  if (process.env.REACT_APP_ENV) {
    return process.env.REACT_APP_ENV;
  }
  
  // Fallback to NODE_ENV
  if (process.env.NODE_ENV) {
    return process.env.NODE_ENV;
  }
  
  // Default to development
  return 'development';
};

const environment = getEnvironment();
const isProduction = environment === 'production';

// Select config based on environment
const config = isProduction ? prodConfig : devConfig;

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${config.API_BASE_URL}/${cleanEndpoint}`;
};

// Helper function to get endpoint
export const getEndpoint = (endpointKey) => {
  return config.ENDPOINTS[endpointKey] || endpointKey;
};

// Helper function to get full URL for endpoint
export const getFullApiUrl = (endpointKey) => {
  const endpoint = getEndpoint(endpointKey);
  return getApiUrl(endpoint);
};

// Export config (helpers already exported above)
export default config;

// Log current environment (only in development)
if (!isProduction) {
  console.log('🔧 Using development configuration');
  console.log('📍 API Base URL:', config.API_BASE_URL);
} else {
  console.log('🚀 Using production configuration');
}

